type QueryParams = Record<string, string | string[] | undefined>;

const clearFiltersFromQuery = (routerQuery: QueryParams): QueryParams => {
  const { q, ...noFilter } = routerQuery;
  const searchKey = typeof q === 'string' ? q.split(':')[0].trim() : undefined;
  return searchKey && searchKey.length ? { ...noFilter, q: searchKey } : noFilter;
};

export default clearFiltersFromQuery;
